<h1
  mat-dialog-title
  class="d-flex align-items-center">
  {{ ("transferInvitee" | i18n) || "Umbuchen" | firstUppercase }}
  <mat-icon
    class="mx-2 mat-info-icon-pointer transfer"
    svgIcon="swap"></mat-icon>
</h1>
<div
  mat-dialog-content
  data-cy="transfer-invitee-dialog-content">
  <div class="transfer-invitee-dialog">
    <app-job-type-select
      class="light-form-field mb-4"
      [selectedJobType]="(selectedJobType$ | async) ?? undefined"
      (selectionChanged)="onJobTypeChange($event)"
      [required]="true"
      [lightFormField]="true"
      data-cy="transfer-invitee-job-type-select"></app-job-type-select>
    <app-department-select
      data-cy="transfer-invitee-department-select"
      (departmentSelectionChanged)="selectDepartment($event)"
      [autoSelectOnlyDepartment]="true"
      [InviteeUserId]="data.inviteeUserId"
      [required]="true"></app-department-select>
    <div
      *ngIf="poolerDoesNotHaveJobType$ | async"
      class="pooler-job-type-warning mt-3"
      data-cy="transfer-invitee-pooler-job-type-warning">
      <span>{{ "poolerDoesNotHaveSelectedJobType" | i18n }}</span>
    </div>
  </div>
  <div class="d-flex align-items-start flex-column mb-4">
    <mat-label>{{ "shift" | i18n | titlecase }} *</mat-label>
    <div
      *ngFor="let shift of shifts; let i = index"
      class="shift">
      <span
        class="shift-label"
        data-cy="shift-label">
        {{
          shift.label
            ? shift.label
            : ("shifts." + shift.shift | i18n | titlecase)
        }}
        ( {{ shift.from | time }} - {{ shift.to | time }} )
      </span>

      <mat-icon
        svgIcon="pencil-outline"
        matListIcon
        class="edit-icon"
        (click)="openShiftEditDialog($event, shift)"
        data-cy="edit-shift-button"
        [matTooltip]="('editTimes' | i18n) || 'Zeiten bearbeiten'">
      </mat-icon>
    </div>
  </div>
  <div class="d-flex align-items-start flex-column mb-4">
    <mat-label>{{
      ("inviteeTransferReason" | i18n) || "Umbuchungs grund"
    }}</mat-label>
    <textarea
      [(ngModel)]="transferReason"
      matInput
      name="description"
      [placeholder]="('description' | i18n) || 'beschreibung' | titlecase"
      style="margin-top: 10px"></textarea>
    <mat-checkbox
      *ngIf="transferReason"
      [(ngModel)]="informInviteeOfReason"
      name="informInvitee"
      data-cy="inform-invitee-of-transfer-reason">
      {{ ("informInviteeOfReason" | i18n) || "Pooler über Grund Informieren" }}
    </mat-checkbox>
  </div>
  <div
    *ngIf="department$ | async as department"
    class="d-flex flex-column mb-4"
    data-cy="transfer-invitee-destination-section">
    <mat-label>{{ "transferInviteTarget" | i18n }}</mat-label>
    <mat-progress-spinner
      *ngIf="loadingOpenJobs"
      diameter="24"
      mode="indeterminate"
      class="mt-2"
      data-cy="transfer-invitee-open-jobs-loading"></mat-progress-spinner>
    <ng-container *ngIf="!loadingOpenJobs">
      <ng-container *ngIf="selectedJobType$ | async as selectedJobType">
        <ng-container *ngIf="openJobsForTransfer$ | async as openJobs">
          <mat-radio-group
            [(ngModel)]="transferDestinationId"
            name="transferDestination"
            class="transfer-destination-group">
            <div
              class="transfer-open-job-row"
              [class.is-selected]="transferDestinationId === 'new'"
              (click)="transferDestinationId = 'new'"
              data-cy="transfer-invitee-destination-new">
              <mat-radio-button
                value="new"
                class="transfer-destination-radio"
                [attr.aria-label]="'transferCreateNewJob' | i18n"
                (click)="$event.stopPropagation()">
              </mat-radio-button>
              <div class="transfer-open-job-row-body">
                <div class="transfer-new-job-label">
                  {{ "transferCreateNewJob" | i18n }}
                </div>
                <div class="transfer-open-job-scroll">
                  <div
                    class="compact-job-list-item transfer-invitee-job-columns">
                    <div
                      class="compact-job-list-item-column with-fade-right"
                      [ngStyle]="destinationColumnStyle('shift')"
                      data-cy="transfer-open-job-new-date-shift">
                      <app-job-list-item-date-time
                        [job]="data.job"
                        [shifts]="shifts"
                        [withDate]="false"></app-job-list-item-date-time>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              *ngFor="let job of openJobs"
              class="transfer-open-job-row"
              [class.is-selected]="transferDestinationId === job._id"
              (click)="transferDestinationId = job._id"
              [attr.data-cy]="'transfer-open-job-' + job._id">
              <mat-radio-button
                [value]="job._id"
                class="transfer-destination-radio"
                [attr.aria-label]="
                  ('jobTypeEnum.' + (job.jobType || '') | i18n) || job._id
                "
                (click)="$event.stopPropagation()">
              </mat-radio-button>
              <div class="transfer-open-job-row-body">
                <div class="transfer-open-job-scroll">
                  <div
                    class="compact-job-list-item transfer-invitee-job-columns">
                    <div
                      class="compact-job-list-item-column with-fade-right"
                      [ngStyle]="destinationColumnStyle('shift')"
                      data-cy="transfer-open-job-date-shift">
                      <app-job-list-item-date-time
                        [job]="job"
                        [withDate]="false"></app-job-list-item-date-time>
                    </div>
                    <div
                      *ngIf="job.certificates?.length"
                      class="compact-job-list-item-column with-text-ellipsis"
                      [ngStyle]="destinationColumnStyle('certificate')"
                      data-cy="transfer-open-job-certificates">
                      <span [attr.title]="certificatesLabel(job)">
                        {{ certificatesLabel(job) }}
                      </span>
                    </div>
                    <div
                      *ngIf="job.description"
                      class="compact-job-list-item-column with-text-ellipsis"
                      [ngStyle]="destinationColumnStyle('description')"
                      data-cy="transfer-open-job-description">
                      <span [attr.title]="job.description || ''">
                        {{ job.description || "" }}
                      </span>
                    </div>
                    <div
                      *ngIf="job.caseNumber"
                      class="compact-job-list-item-column with-text-ellipsis"
                      [ngStyle]="destinationColumnStyle('caseNumberShort')"
                      data-cy="transfer-open-job-case-number">
                      <span [attr.title]="job.caseNumber || ''">
                        {{ job.caseNumber || "" }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-radio-group>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</div>
<div
  mat-dialog-actions
  *ngIf="!processing">
  <button
    mat-button
    (click)="close()">
    {{ ("close" | i18n) || "close" | uppercase }}
  </button>

  <button
    mat-button
    (click)="transferInvitee()"
    [disabled]="
      (department$ | async) == undefined ||
      loadingOpenJobs ||
      (poolerDoesNotHaveJobType$ | async)
    "
    data-cy="invitee-transfer-submit">
    {{ ("confirm" | i18n) || "confirm" | uppercase }}
  </button>
</div>
